import { createBrowserRouter, RouterProvider, Navigate } from "react-router";
import { ProtectedShell } from "@/pages/ProtectedShell";
import { LoginPage } from "@/pages/LoginPage";
import { LoadingPage } from "@/pages/LoadingPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { StoresPage } from "@/pages/stores/StoresPage";
import { StoreDetailPage } from "@/pages/stores/StoreDetailPage";
import { StoreRemovalRequestsPage } from "@/pages/stores/StoreRemovalRequestsPage";
import { PriceLimitBypassPage } from "@/pages/stores/PriceLimitBypassPage";
import { AppointmentsEnabledRequestsPage } from "@/pages/stores/AppointmentsEnabledRequestsPage";
import { UsersPage } from "@/pages/users/UsersPage";
import { UserDetailPage } from "@/pages/users/UserDetailPage";
import { UserDeletionRequestsPage } from "@/pages/users/UserDeletionRequestsPage";
import { ReportsPage } from "@/pages/reports/ReportsPage";
import { ReportDetailPage } from "@/pages/reports/ReportDetailPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { DefaultMenuCategoriesPage } from "@/pages/DefaultMenuCategoriesPage";
import { FeaturedRewardsPage } from "@/pages/FeaturedRewardsPage";
import { StaffInvitationsPage } from "@/pages/StaffInvitationsPage";
import { EventsExportPage } from "@/pages/export/EventsExportPage";
import { GuestlistReportPage } from "@/pages/GuestlistReportPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/loading", element: <LoadingPage /> },
  {
    path: "/",
    element: <ProtectedShell />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      // Stores — static routes BEFORE :id to prevent collision
      { path: "stores/removal-requests", element: <StoreRemovalRequestsPage /> },
      { path: "stores/price-limit-bypass", element: <PriceLimitBypassPage /> },
      {
        path: "stores/appointments-enabled-requests",
        element: <AppointmentsEnabledRequestsPage />,
      },
      { path: "stores/:id", element: <StoreDetailPage /> },
      { path: "stores", element: <StoresPage /> },
      // Users — static routes BEFORE :uid
      { path: "users/deletion-requests", element: <UserDeletionRequestsPage /> },
      { path: "users/:uid", element: <UserDetailPage /> },
      { path: "users", element: <UsersPage /> },
      // Reports
      { path: "reports/:id", element: <ReportDetailPage /> },
      { path: "reports", element: <ReportsPage /> },
      // Export
      { path: "export/events", element: <EventsExportPage /> },
      { path: "guestlist-report", element: <GuestlistReportPage /> },
      // Other
      { path: "settings", element: <SettingsPage /> },
      { path: "default-menu-categories", element: <DefaultMenuCategoriesPage /> },
      { path: "featured-rewards", element: <FeaturedRewardsPage /> },
      { path: "staff-invitations", element: <StaffInvitationsPage /> },
      // Catch-all — must stay last
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
